export default {
  namespaced: true,
  state: {
    isSpiner: false,
    isInvisibleFilter: false,
    type: null, // pc, sp, tablet
    hType: null, // small middle long
    height: null,
    width: null,
    browser: null,
    isValid: false,
    isInfo: false,
    modalMessage: false,
    isScroll: false,
    isLogoOnly: false,
  },
  mutations: {
    create(state, data) {
      if (data.isSpiner !== undefined) state.isSpiner = data.isSpiner
      if (data.isInvisibleFilter !== undefined)
        state.isInvisibleFilter = data.isInvisibleFilter
      if (data.type !== undefined) state.type = data.type
      if (data.hType !== undefined) state.hType = data.hType
      if (data.height !== undefined) state.height = data.height
      if (data.width !== undefined) state.width = data.width
      if (data.browser !== undefined) state.browser = data.browser
      if (data.isValid !== undefined) state.isValid = data.isValid
      if (data.isInfo !== undefined) state.isInfo = data.isInfo
      if (data.modalMessage !== undefined)
        state.modalMessage = data.modalMessage
      if (data.isScroll !== undefined) state.isScroll = data.isScroll
      if (data.isLogoOnly !== undefined) state.isLogoOnly = data.isLogoOnly
    },
    destroy(state, data) {
      state.isSpiner = false
      state.isInvisibleFilter = false
      state.type = null
      state.hType = null
      state.height = null
      state.width = null
      state.browser = null
      state.isValid = false
      state.isInfo = false
      state.modalMessage = false
      state.isScroll = false
      state.isLogoOnly = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/screen.js